import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ChartSectionCollapseStore {
  collapsedByProvider: Record<string, Record<string, boolean>>;
  setCollapsed: (
    providerId: string,
    sectionKey: string,
    collapsed: boolean,
  ) => void;
}

export const useChartSectionCollapseStore = create<ChartSectionCollapseStore>()(
  persist(
    (set) => ({
      collapsedByProvider: {},
      setCollapsed: (providerId, sectionKey, collapsed) =>
        set((state) => ({
          collapsedByProvider: {
            ...state.collapsedByProvider,
            [providerId]: {
              ...state.collapsedByProvider[providerId],
              [sectionKey]: collapsed,
            },
          },
        })),
    }),
    {
      name: "chart-section-collapse-store",
      partialize: (state) => ({
        collapsedByProvider: state.collapsedByProvider,
      }),
    },
  ),
);
